import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';

type SeatSearchInputProps = {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
};

/**
 * Email-substring filter input for the seats table. Controlled — `GroupCard`
 * owns the search state so resetting on filter-tab change (clearSelection-style)
 * stays in one place.
 */
export function SeatSearchInput({ value, onChange, placeholder = 'Search member...' }: SeatSearchInputProps) {
  return (
    <div className="relative w-full">
      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
        <MagnifyingGlassIcon className="w-5 h-5" aria-hidden="true" />
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Search seats by email"
        className="block w-full py-2 pr-3 !text-sm text-gray-900 bg-white border border-gray-200 rounded-md pl-10 placeholder:text-gray-400 focus:border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300"
      />
    </div>
  );
}
